import React from "react";
import { Link } from "react-router-dom";
import { MINIO_URL } from "../config";

function GameCard({ game }) {
    return (
        <Link to={`/game/${game.id}`} className="group block bg-gradient-to-br from-[#6366f1]/90 via-[#8b5cf6]/90 via-[#a855f7]/90 to-[#ec4899]/90 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 border-4 border-[#fbbf24]/50 hover:border-[#fbbf24]/80 backdrop-blur-sm joy-hover relative">
            {/* Decorative corner emojis */}
            <div className="absolute top-2 right-2 text-xl opacity-0 group-hover:opacity-100 transition-opacity animate-sparkle">✨</div>
            <div className="absolute top-2 left-2 text-lg opacity-0 group-hover:opacity-100 transition-opacity animate-twinkle" style={{ animationDelay: '0.2s' }}>⭐</div>
            
            <div className="w-full h-64 bg-gradient-to-br from-[#3b82f6] via-[#8b5cf6] to-[#ec4899] overflow-hidden relative">
                <img src={`${MINIO_URL}${game.id}/${game.thumb}`} alt={game.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#6366f1]/90 via-[#8b5cf6]/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </div>
            <div className="p-3 bg-gradient-to-br from-[#6366f1]/90 via-[#8b5cf6]/90 via-[#a855f7]/90 to-[#ec4899]/90 backdrop-blur-sm">
                <div className="font-semibold text-white group-hover:text-[#fef3c7] transition-colors drop-shadow-lg">{game.name}</div>
                <div className="text-xs text-[#fef3c7] mt-1">{game.category}</div>
            </div>
        </Link>
    );
}
export default GameCard;